<script>
import RegionalCommissionMixin from '@/mixin/common/RegionalCommissionMixin'
import { cache, cacheName } from '@/utils/cacheManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  mixins: [RegionalCommissionMixin],
  data() {
    const hqViewAllList = this.$checkPermission(['role_hqViewAllListAtBusiness']) || this.$checkPermission(['role_hqViewAllDetailAtBusines'])
    const hqViewAllDetail = this.$checkPermission(['role_hqViewAllDetailAtBusines'])
    let hierarchyViewDetail = false
    if (this.isZy) {
      hierarchyViewDetail = !hqViewAllList && this.$checkPermission(['role_ViewHierarchicalDetailAtBusiness'])
    } else {
      hierarchyViewDetail = this.$checkPermission(['role_ViewHierarchicalDetailAtBusiness'])
    }
    return {
      hqViewAllList,
      hqViewAllDetail,
      hierarchyViewDetail,
      enableCommission: false,
      isZy: false,
      childOfficeIds: []
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.enableCommission = cache.config.get('enableCommission') === '1'
        this.isZy = String(cache.config.get('ToExoSystem')) === 'zy'
        this.childOfficeIds = JobUtils.getChildOfficeIds(this.$store.getters.currentOfficeUuid)
      }
    }
  },
  methods: {
    // 匹配所属分公司
    matchOwnerBranch(row) {
      if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.matchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
        return false
      }
      return true
    },
    // 匹配协作分公司
    matchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    }
  }
}
</script>
